import { Component, OnInit, NgZone, Renderer2, HostListener, Input, Output, EventEmitter, } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeHtml, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import swal from 'swal-forms';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from 'moment'
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";
import imageToBase64 from 'image-to-base64/browser';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';



import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';
import { ScriptService } from '../services/script.service';


@Component({
    selector: 'app-mention',
    templateUrl: './mention.component.html',
    styleUrls: ['./mention.component.css']
})
export class MentionComponent implements OnInit {
    
    public project_id: any = {};
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public sentiment = 0;
    public country = '';
    public text_search = '';
    public checked_sm: any = { all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false, linkedin: false, reddit: false };
    public mmapLoading = false;
    public popularLoading = false;
    public popular_mentions = [];
    public mentions: any = [];
    public countries: any = {};
    public total_per_sm: any = {};
    public blocked_items: any = {};
    public viewed_items: any = {};
    public list_view_class = 'mention-grid';
    public viewed_mention = [];
    public view_modal: boolean = false;
    public modal_content: any = {};
    public embed_url: SafeResourceUrl;
    public embed_fb: SafeResourceUrl;
    public embed_reddit = '';
    public language = 'any';
    public group_by_date = [];
    public datewise: any = {};
    public load_more = true;

    p: number = 0;
    total: number = 0;
    page_length: number = 100;

    public lineChartData = [];
    public lineChartLabels = [];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public lineChartPlugins = [];
    //  public lineChartColors: Color[] = [ { borderColor: '#0FB36C' } ];
    public lineChartOptions: (ChartOptions & { annotation: any }) = {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: true },
        scales: {
            yAxes: [
                {
                    ticks: {
                        maxTicksLimit: 5
                    }
                }
            ],
            xAxes: [
                {
                    type: 'time',
                    distribution: 'series',
                    time: {
                        tooltipFormat: 'DD MMM',
                        displayFormats: {
                            'millisecond': '',
                            'second': 'DD MMM',
                            'minute': 'DD MMM',
                            'hour': 'DD MMM',
                            'day': 'DD MMM',
                            'week': 'DD MMM',
                            'month': 'DD MMM',
                            'quarter': 'DD MMM',
                            'year': 'DD MMM',
                        }
                    }
                },
            ]
        },
        annotation: {},
    };

    sentimant_filter_value = 0;
    sentimant_filter_options = {
        showTicksValues: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        stepsArray: [
            { value: -1, legend: "Negative" },
            { value: 0, legend: "All" },
            { value: 1, legend: "Positive" }
        ]
    };

    public selected: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [moment().subtract(3, 'month'), moment()]
    };

    header_data: any = { heading: "Mentions" };
    mentions_date_count: any = [];
    context_menu: any = false;
    offset:number;
    insta_test_img: any;

        
    constructor(private script: ScriptService, private _sanitizer: DomSanitizer, private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService, lc: NgZone, private renderer: Renderer2, private http: HttpClient) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.name = login.get_session_data('ieye_session_name');
        this.session_data.email = login.get_session_data('ieye_session_email');
        this.service.setTitle('Mentions | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };

        if (this.route.snapshot.queryParams["sentiment"]) {
            this.sentiment = this.route.snapshot.queryParams["sentiment"];
            this.sentimant_filter_value = this.sentiment == 2 ? 0 : this.route.snapshot.queryParams["sentiment"];
        }
        if (this.route.snapshot.queryParams["channels"] && this.route.snapshot.queryParams["channels"] == 'sm') {
            this.checked_sm = { all: false, twitter: true, facebook: true, instagram: true, web: false, youtube: true, reviews: false, others: false, linkedin: false, reddit: false };
        }
    }

    ngOnInit(): void {
        //        this.loadScripts();
        this.countries = this.get_countries();
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
      //  this.testImage();
        this.offset = (new Date().getTimezoneOffset());

       
    }

//    onScroll() {
//        let page = this.p + 1;
//        this.pageChanged(page);
//    }

    showMention(event) {
        this.p = 1;
        this.page_length = event.target.value;
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    private loadScripts() {
        this.script.load('reddit', 'fb').then(data => {
        }).catch(error => console.log(error));
    }

    public change_list_view(view) {
        this.spinner.show();
        setTimeout(() => {
            this.list_view_class = view;
            this.spinner.hide();
        }, 500);
    }

    public closeModal() {
        this.renderer.removeClass(document.body, 'modal-open');
        this.view_modal = false;
    }

    public async viewLog(mention) {
        var formData = { user_id: this.session_data.id, mention_id: mention.id, data: mention }
        await this.service.form_actions(formData, 'mention_view');
        this.viewed_mention.push(mention.id);
    }

    public async openModal(mention) {
        this.embed_url = '';
        this.embed_fb = '';
        this.modal_content = {};
        var formData = { user_id: this.session_data.id, mention_id: mention.id, data: mention }
        this.spinner.show();
        this.result = await this.service.form_actions(formData, 'mention_view');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
            this.spinner.hide();
        } else {
            this.renderer.addClass(document.body, 'modal-open');
            this.modal_content = this.result.mention;
            if (this.modal_content.embed_url)
                this.embed_url = this._sanitizer.bypassSecurityTrustResourceUrl(this.modal_content.embed_url);

            this.view_modal = true;
            this.viewed_mention.push(mention.id);
            this.spinner.hide();
        }
    }

    datesUpdated(range) {
        if (range.startDate != null && range.endDate != null) {
            this.p = 0;
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
            this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
            this.get_mentions(this.selected.startDate, this.selected.endDate);
        }
    }

    public async get_mentions_graph(start, end) {
        this.mmapLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'mentions_map');
        formData.append("sentiment_data", true);
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", this.page_length);
        formData.append("page_no", this.p);
        formData.append("pager", this.total);
        //formData.append("sentiment", this.sentiment);
        formData.append("country", this.country);
        formData.append("text_search", this.text_search);
        formData.append("channels[twitter]", this.checked_sm.twitter);
        formData.append("channels[facebook]", this.checked_sm.facebook);
        formData.append("channels[instagram]", this.checked_sm.instagram);
        formData.append("channels[web]", this.checked_sm.web);
        formData.append("channels[youtube]", this.checked_sm.youtube);
        formData.append("channels[reviews]", this.checked_sm.reviews);
        formData.append("channels[others]", this.checked_sm.others);
        formData.append("channels[linkedin]", this.checked_sm.linkedin);
        formData.append("channels[reddit]", this.checked_sm.reddit);
        formData.append("channels[all]", this.checked_sm.all);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        if (this.language != 'any') {
            formData.append("language", this.language);
        }
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
            this.mmapLoading = false;
        } else {
            //this.lineChartOptions.scales.yAxes = {min:0, max:5, stepSize: 0.5};
            this.lineChartData = [
                { data: this.result.data, label: 'Mentions', borderWidth: 2, pointRadius: 2, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#0077CC', pointBorderColor: '#0077CC', pointBackgroundColor: '#0077CC' },
                { data: this.result.positive_data, label: 'Positive Mentions', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#45D52B', pointBorderColor: '#45D52B', pointBackgroundColor: '#45D52B' },
                { data: this.result.negative_data, label: 'Negative Mentions', borderWidth: 2, pointRadius: 2, lineTension: 1, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: false, borderColor: '#FF0000', pointBorderColor: '#FF0000', pointBackgroundColor: '#FF0000' },
            ];
            this.mmapLoading = false;
        }
    }

    public async get_mentions(start, end) {
        this.spinner.show();
        this.popularLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'all');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", this.page_length);
        formData.append("page_no", this.p);
        formData.append("pager", this.total);
        formData.append("sentiment", this.sentiment);
        formData.append("country", this.country);
        formData.append("text_search", this.text_search);
        formData.append("channels[twitter]", this.checked_sm.twitter);
        formData.append("channels[facebook]", this.checked_sm.facebook);
        formData.append("channels[instagram]", this.checked_sm.instagram);
        formData.append("channels[web]", this.checked_sm.web);
        formData.append("channels[youtube]", this.checked_sm.youtube);
        formData.append("channels[reviews]", this.checked_sm.reviews);
        formData.append("channels[others]", this.checked_sm.others);
        formData.append("channels[linkedin]", this.checked_sm.linkedin);
        formData.append("channels[reddit]", this.checked_sm.reddit);
        formData.append("channels[all]", this.checked_sm.all);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        if (this.language != 'any') {
            formData.append("language", this.language);
        }
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            this.popularLoading = false;
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.popularLoading = false;
            this.total = this.result.count;
//            this.popular_mentions = this.popular_mentions.concat(this.result.data.mentions);
            this.popular_mentions = this.result.data.mentions;
//            this.mentions = this.result.mentions; console.log(this.mentions);
            this.blocked_items.mentions = this.result.user.blocked_mentions;
            this.blocked_items.profiles = this.result.user.blocked_profiles;
            this.viewed_items = this.result.user.viewed_mentions;
            this.datewise = this.result.datewise;
            this.mentions_date_count = this.result.mentions;
            this.spinner.hide();
            this.load_more = true;
        }
    }

    public can_show_mention(id, profile_id) {
        var mentions = JSON.stringify(this.blocked_items.mentions);
        var profiles = JSON.stringify(this.blocked_items.profiles);
        if (mentions.indexOf(id) !== -1 || profiles.indexOf(profile_id) !== -1) {
            return 'none';
        }
        return 'block';
    }

    public convertUTC(date){
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().format('YYYY-MM-DD');
        return local;
    }

    public already_seen(id) { //console.log(this.viewed_items);
        var list = JSON.stringify(this.viewed_items);
        if (list.indexOf(id) !== -1) {
            return true;
        }
        return false;
    }

    public sm_checkbox_event(e) {
        const queryParams = { channels: 'selected' };
        this.remove_params(queryParams);
        this.popular_mentions = [];
        this.p = 1;
        if ('all' == e.target.value) {
            this.checked_sm.twitter = this.checked_sm.facebook = this.checked_sm.web = this.checked_sm.instagram = this.checked_sm.youtube = this.checked_sm.reviews = this.checked_sm.others = this.checked_sm.linkedin = this.checked_sm.reddit = false;
        }
        if ('twitter' == e.target.value)
            this.checked_sm.twitter = e.target.checked ? true : false;
        if ('facebook' == e.target.value)
            this.checked_sm.facebook = e.target.checked ? true : false;
        if ('web' == e.target.value)
            this.checked_sm.web = e.target.checked ? true : false;
        if ('instagram' == e.target.value)
            this.checked_sm.instagram = e.target.checked ? true : false;
        if ('youtube' == e.target.value)
            this.checked_sm.youtube = e.target.checked ? true : false;
        if ('reviews' == e.target.value)
            this.checked_sm.reviews = e.target.checked ? true : false;
        if ('others' == e.target.value)
            this.checked_sm.others = e.target.checked ? true : false;
        if ('linkedin' == e.target.value)
            this.checked_sm.linkedin = e.target.checked ? true : false;
        if ('reddit' == e.target.value)
            this.checked_sm.reddit = e.target.checked ? true : false;

        if (this.checked_sm.linkedin && this.checked_sm.reddit) {
            this.checked_sm.others = true;
        } else {
            this.checked_sm.others = false;
        }

        if (this.checked_sm.twitter || this.checked_sm.facebook || this.checked_sm.web || this.checked_sm.instagram || this.checked_sm.youtube || this.checked_sm.reviews || this.checked_sm.others || this.checked_sm.linkedin || this.checked_sm.reddit) {
            this.checked_sm.all = false;
        } else {
            this.checked_sm.all = true;
        }

        //        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public clear_filter() {
        const queryParams = { sentiment: 0, channels: 'all' };
        this.checked_sm = { all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false, linkedin: false, reddit: false };
        this.remove_params(queryParams);
        this.p = 1;
        this.sentiment = 0;
        this.sentimant_filter_value = 0;
        this.country = '';
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public pageChanged(page) {
      //  console.log(this.total)
      //  console.log(this.page_length)
       // console.log(this.p)
      //  console.log(page)
        let total_pages = this.total / this.page_length;
        //console.log(total_pages)
       // if (total_pages >= this.p) {
            this.p = page;
            this.scrollToFirstInvalidControl();
            //this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
            this.get_mentions(this.selected.startDate, this.selected.endDate);
        //}
    }

    scrollToFirstInvalidControl() {
        const classElement: HTMLCollection = document.getElementsByClassName('group_by_date');
        setTimeout(() => {
            if (classElement.length > 0) {
                classElement[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
            }
        }, 1000);
    }

    public language_filter() {
        this.popular_mentions = [];
        this.p = 1;
        var language = (<HTMLInputElement>document.getElementById('language_filter')).value;
        this.language = language;
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public search_by_word(val) {
        this.popular_mentions = [];
        this.p = 1;
        if (val.trim() == '')
            return false;
        this.text_search = val;
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public clear_by_word() {
        this.popular_mentions = [];
        this.p = 1;
        this.text_search = '';
        this.language = 'any';
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public remove_params(queryParams) {
        this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams: queryParams,
                queryParamsHandling: 'merge', // remove to replace all query params by provided
            });
    }

    public senitment_filter_event(val) {
        this.popular_mentions = [];
        const queryParams = { sentiment: val };
        this.remove_params(queryParams);
        this.p = 1;
        this.sentiment = val;
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public filter_by_country(event) {
        this.popular_mentions = [];
        this.p = 1;
        this.country = event.target.value;
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate);
    }

    public async get_countries() {
        this.result = await this.service.get_actions({}, 'countries');
        this.countries = this.result;
    }

    public delete_mention(mention) {
        var profile_id = mention.profile_id;
        var mention_id = mention.id;
        var mention_name = mention.name ? mention.name : mention.title;
        var profile_name = mention.profile_name ? mention.profile_name : mention_name;
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete Mention',
            cancelButtonText: 'Cancel',
            denyButtonText: 'Block Profile',
        }).then((action) => {
            if (action.isConfirmed) {
                this.action_delete('mention', mention_id, mention_name, profile_name);
            } else if (action.isDenied) {
                this.action_delete('profile', profile_id, mention_name, profile_name);
            }
        });
    }

    public async action_delete(action, id, mention_name, profile_name) {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", action);
        formData.append("id", id);
        formData.append("mention_name", mention_name);
        formData.append("profile_name", profile_name);
        //        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'block_mention');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.pageChanged(this.p);
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 });
        }
    }

    public change_date_format(date, format) {
//        return moment.tz(date, 'Asia/Muscat').utc().format(format);
        let new_date = new Date(date+' UTC');
        return date ? date.toString() : '' // "Wed Jun 29 2011 09:52:48 GMT-0700 (PDT)"
    }

    public change_date_moment(date) {
        return moment(date).format("MMMM DD YYYY ")
    }

    public get_social_icon(channel) {
        switch (channel) {
            case 'web': {
                return 'assets/images/icons/share-2.svg';
                break;
            }
            case 'facebook': {
                return 'assets/images/icons/facebook.svg';
                break;
            }
            case 'instagram': {
                return 'assets/images/icons/instagram.svg';
                break;
            }
            case 'twitter': {
                return 'assets/images/icons/twitter.svg';
                break;
            }
            case 'youtube': {
                return 'assets/images/icons/youtube.svg';
                break;
            }
            case 'linkedin': {
                return 'assets/images/icons/linkedin.svg';
                break;
            }
            case 'reviews': {
                return 'assets/images/icons/message-square.svg';
                break;
            }
            default: {
                return 'assets/images/icons/rss.svg';
                break;
            }
        }
    }

    public async get_mentions_per_sm(start, end) {
        this.total_per_sm.all = this.total_per_sm.twitter = this.total_per_sm.facebook = this.total_per_sm.instagram = this.total_per_sm.web = this.total_per_sm.youtube = this.total_per_sm.reviews = this.total_per_sm.others = this.total_per_sm.linkedin = this.total_per_sm.reddit = '<img src="assets/images/small-loader.gif">';
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'count_per_sm');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 10);
        formData.append("sentiment", this.sentiment);
        formData.append("country", this.country);
        formData.append("text_search", this.text_search);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        if (this.language != 'any') {
            formData.append("language", this.language);
        }

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.total_per_sm.all = this.result.data.all;
            this.total_per_sm.web = this.result.data.web;
            this.total_per_sm.twitter = this.result.data.twitter;
            this.total_per_sm.facebook = this.result.data.facebook;
            this.total_per_sm.instagram = this.result.data.instagram;
            this.total_per_sm.youtube = this.result.data.youtube;
            this.total_per_sm.reviews = this.result.data.reviews;
            this.total_per_sm.others = this.result.data.others;
            this.total_per_sm.linkedin = this.result.data.linkedin;
            this.total_per_sm.reddit = this.result.data.reddit;
        }
    }

    public async send_email(mention) {
        const { value: formValues } = await Swal.fire({
            title: 'Mention Notification',
            customClass: {
                container: 'mention_popup'
            },
            html:
                '<div><label>Email Address:</label> <input id="email-input"><div class="swal2-validation-message" id="swal2-validation-message" style="display: none;">Please select a project</div>' +
                '<div class="sub_tit">Subject: Mention Notification</div>' +
                '<div><label>Your Comment:</label> <textarea id="message-input">I am sending to you an interesting mention found in the Internet by 24ieye</textarea></div>' +
                '<div class="sub_tit">Mention Content: </div>' +
                '<div class="sub_tit"><img src="' + this.get_social_icon(mention.mchannel) + '"></div>' +
                '<div class="detail-section"><span>' + mention.name + '</span><br><span>' + mention.description + '</span></div>',
            showCancelButton: true,
            confirmButtonText: 'Send',
            preConfirm: () => {
                var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                var email = (<HTMLInputElement>document.getElementById('email-input')).value;
                email = email.trim();
                var message = (<HTMLInputElement>document.getElementById('message-input')).value;
                document.getElementById("swal2-validation-message").style.display = "none";
                if (email === '') {
                    document.getElementById("swal2-validation-message").style.display = "block";
                    document.getElementById("swal2-validation-message").innerHTML = "Please enter the email address.";
                    return false;
                } else if (!email.match(mailformat)) {
                    document.getElementById("swal2-validation-message").style.display = "block";
                    document.getElementById("swal2-validation-message").innerHTML = "Please enter the valid email address.";
                    return false;
                }
                return { user_id: this.session_data.id, from_name: this.session_data.name, from_email: this.session_data.email, subject: 'Mention Notification', to: email, comment: message, mention: mention, datetime: this.change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a'), website: mention.link.split("/")[2] }
            }
        })

        if (formValues) {
            this.spinner.show();
            this.result = await this.service.form_actions(JSON.stringify(formValues), 'mention_notification_email');
            if (this.result.status == false) {
                if (this.result.code == 202) {
                    this.err = {};
                    Swal.fire('Alert!', this.result.message, 'error');
                } else {
                    this.err = this.result.errors;
                }
                this.spinner.hide();
            } else {
                this.spinner.hide();
                Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            }
        }

    }


    public country_filter(code, type) {
        var country_data = this.countries.filter(x => x.cca2 == code);
        return country_data.length != 0 ? country_data[0][type] : '';
    }

    public no_of_results(date) {
        //console.log(date);
      // return this.datewise[date] === undefined ? '' : this.datewise[date];
      
        return this.datewise[date] === undefined ? '1' : this.datewise[date];
    }

    public async google_translate(event, mention) {
        var to = event.target.value;
        var source = mention.lang_detected;
        if (to == '')
            return false;
        if (to != '' || to !== undefined) {
            let form_data = { target: to, source: source, mention: mention }
            this.spinner.show();
            this.result = await this.service.form_actions(form_data, 'translation');
            if (this.result.status == false) {
                if (this.result.code == 202) {
                    this.err = {};
                    Swal.fire('Alert!', this.result.message, 'error');
                } else {
                    this.err = this.result.errors;
                }
                this.spinner.hide();
            } else {
                this.spinner.hide();
                Swal.fire({
                    title: this.result.data.title,
                    text: this.result.data.description,
                    //                imageUrl: 'https://unsplash.it/400/200',
                    //                imageWidth: 400,
                    //                imageHeight: 200,
                    //                imageAlt: 'Custom image',
                });
            }
        }
    }

   async instagram_image(url) {
        let image = url.replace("Microsoft", "W3Schools");  
        
     //   url = 'https://instagram.fdnk3-1.fna.fbcdn.net/v/t51.2885-15/308001697_3222560451294393_1684876209353328267_n.jpg?stp=dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fdnk3-1.fna.fbcdn.net&_nc_cat=109&_nc_ohc=SUa5lpoeRgsAX82vAM0&edm=ABZsPhsBAAAA&ccb=7-5&oh=00_AT9bUbQR5ePcaZupuiqLnaPne1H6CXyu9PoEuPewoqkrRA&oe=6330C7E4&_nc_sid=4efc9f';

     /*   var formData = { url: url }
       this.result = await this.service.form_actions(formData, 'mention_image');
       
       return this.result ? 'data:image/png;base64,' + this.result.data : image;*/
       return image;
    }    

    @HostListener('document:contextmenu', ['$event'])
    onRightClick(event: any, item: any, link:any){
        console.log(item)
        if(!item)
            item = {};
            this.modal_content.context_menu = true

        item.context_menu = true;        
        if(item.profile_type_name == 'reddit'){
            //link = "https://www.reddit.com" + item.link;
            link = item.link;
        }
        item.right_link = link;
        return false;    
    }

    closeVist(item: any){
        if(!item)
            item = {};
            this.modal_content.context_menu = false
        item.context_menu = false;
    }
    

    send_whatsapp(mention: any){    
        let url = 'https://api.whatsapp.com/send?text='+mention.description;   
        window.open(url, "_blank");
    }

   
    async testImage() {
        let url = 'https://instagram.fdnk3-1.fna.fbcdn.net/v/t51.2885-15/308001697_3222560451294393_1684876209353328267_n.jpg?stp=dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fdnk3-1.fna.fbcdn.net&_nc_cat=109&_nc_ohc=SUa5lpoeRgsAX82vAM0&edm=ABZsPhsBAAAA&ccb=7-5&oh=00_AT9bUbQR5ePcaZupuiqLnaPne1H6CXyu9PoEuPewoqkrRA&oe=6330C7E4&_nc_sid=4efc9f';

       /* var formData = { url: url }
       this.result = await this.service.form_actions(formData, 'mention_image');
       this.insta_test_img = 'data:image/png;base64,' + this.result.data;*/

      /* var formData = { url: url }
       this.result = await this.service.common_actions(formData, 'http://localhost/test/common');
       //this.insta_test_img = 'data:image/png;base64,' + this.result.data;
      console.log(this.result);*/
      
     
    }

    



}
